import React, { useState, useEffect, useRef } from 'react';
import api from '../api';
import './Settings.css';

const FUTURE_TEMPLATES = [
  { name: 'Bank Statement Template', comingSoon: true },
];

export default function Settings() {
  const [templates, setTemplates] = useState([]);
  const fileRefs = useRef({});

  const fetchTemplates = async () => {
    try {
      const res = await api.get('/templates');
      setTemplates(res.data.templates);
    } catch (err) {
      console.error('Failed to load templates:', err);
    }
  };

  useEffect(() => { fetchTemplates(); }, []);

  const handleUpload = async (key, e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    try {
      await api.post(`/templates/${key}/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      fetchTemplates();
    } catch (err) {
      console.error('Upload failed:', err);
    }
  };

  const handleDelete = async (key) => {
    try {
      await api.delete(`/templates/${key}`);
      fetchTemplates();
    } catch (err) {
      console.error('Delete failed:', err);
    }
  };

  return (
    <div className="settings-page">
      <h1 className="page-title">Settings</h1>

      <section className="settings-section">
        <h2 className="section-title">Templates</h2>

        <div className="template-list">
          {templates.map(tpl => (
            <div key={tpl.key} className="template-row">
              <div className="template-info">
                <span className="template-name">{tpl.name}</span>
                {tpl.exists ? (
                  <span className="template-date">
                    Uploaded {new Date(tpl.uploadedAt).toLocaleDateString()}
                  </span>
                ) : (
                  <span className="template-status">Not uploaded</span>
                )}
              </div>
              <div className="template-actions">
                <input
                  type="file"
                  accept={tpl.accept || '.xlsx'}
                  ref={el => fileRefs.current[tpl.key] = el}
                  onChange={e => handleUpload(tpl.key, e)}
                  style={{ display: 'none' }}
                />
                <button
                  className="btn-template"
                  onClick={() => fileRefs.current[tpl.key]?.click()}
                >
                  {tpl.exists ? 'Re-upload' : 'Upload'}
                </button>
                {tpl.exists && (
                  <button
                    className="btn-template btn-delete"
                    onClick={() => handleDelete(tpl.key)}
                  >
                    Delete
                  </button>
                )}
              </div>
            </div>
          ))}

          {FUTURE_TEMPLATES.map((tpl, i) => (
            <div key={i} className="template-row template-disabled">
              <div className="template-info">
                <span className="template-name">{tpl.name}</span>
                <span className="template-coming-soon">Coming Soon</span>
              </div>
              <div className="template-actions">
                <button className="btn-template" disabled>Upload</button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
